import ClientAgent from '../clientAgent'

export default class ClientAgentExtender {
  _ca = null

  /**
   * @returns {ClientAgent}
   */
  get ca () {
    if (this._ca === null) {
      this._ca = new ClientAgent()
    }
    return this._ca
  }

  set ca (value) {
    this._ca = value
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/Common/clientAgentExtender.js